import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

function getErrorByPath(errors, path) {
  if (!errors || !path) return undefined;
  return path.split(".").reduce((current, segment) => {
    if (current == null) return undefined;
    return current[segment];
  }, errors);
}

const TextField1 = ({
  control,
  watchValue,
  errors,
  placeholder,
  multiErrorFields,
  disabled,
  type,
  textarea,
  name,
  autoFocus,
  handleFocus,
  handleBlur,
  maxLength,
  minLength,
  onKeyDown,
  rows,
  defaultValue,
  rules,
  errorIcon,
  successIcon,
  readOnly,
  required,
  min,
  max,
  step,
  onClick,
  ref,
  textCountVisible,
  textcount,
  textCountTotal,
  onChange,
  onWheel,
  autoCapitalize,
  forceShowError,
}) => {
  const fieldError = getErrorByPath(errors, name);
  const hasError = forceShowError || fieldError !== undefined;

  return (
    <>
      <Controller
        defaultValue={defaultValue}
        render={({ field: { onChange: controllerOnChange, value, ref: fieldRef } }) => (
          <>
            <Form.Control
              className={`${hasError ? "is-invalid" : ""} ${
                value &&
                rules.pattern &&
                rules.pattern.value &&
                rules.pattern.value.test(value)
                  ? "regex-match-class"
                  : ""
              }`}
              name={name}
              ref={(element) => {
                fieldRef(element);
                if (typeof ref === "function") {
                  ref(element);
                } else if (ref) {
                  ref.current = element;
                }
              }}
              placeholder={placeholder}
              autoFocus={autoFocus}
              disabled={disabled}
              autoComplete="off"
              required={required}
              type={type}
              as={textarea}
              readOnly={readOnly}
              rows={rows}
              onBlur={handleBlur}
              onKeyDown={onKeyDown}
              maxLength={maxLength}
              minLength={minLength}
              min={min}
              max={max}
              step={step}
              onWheel={onWheel}
              onFocus={(e) => {
                handleFocus && handleFocus(e);
              }}
              defaultValue={defaultValue}
              onChange={(e) => {
                e.target.classList?.remove("invalid-field-focused");
                controllerOnChange &&
                  controllerOnChange(e.target.value.trimLeft());
                onChange && onChange(e);
              }}
              onClick={onClick}
              value={watchValue?.toString() || value ? value?.toString() : ""}
              autoCapitalize={autoCapitalize}
            />
          </>
        )}
        name={name}
        control={control}
        rules={rules}
      />
      {multiErrorFields?.length > 0 ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ messages }) => {
            if (messages) {
              const isMultipleError = Object.keys(messages).every(
                (errKey) =>
                  multiErrorFields.filter((m) => m[errKey] !== undefined)
                    .length > 0
              );
              if (isMultipleError) {
                const arr = [];
                for (const fieldError of multiErrorFields) {
                  const key = Object.keys(fieldError)[0];
                  const success = Object.keys(messages).includes(key);
                  arr.push(
                    <div className={success ? "red" : "green"} key={key}>
                      <span key={key}>
                        <i className={success ? errorIcon : successIcon} />
                        {fieldError[key]}
                      </span>
                    </div>
                  );
                }
                return (
                  <div className="errorMsg 2 show passwordcustom">{arr}</div>
                );
              } else {
                return (
                  <div className="errorMsg 1 show">
                    <i className={errorIcon} />
                    {fieldError?.message}
                  </div>
                );
              }
            } else {
              return <div className="errorMsg 3"></div>;
            }
          }}
        />
      ) : hasError ? (
        <div className="errorMsg 4 show">
          <span>
            <i className={errorIcon} />
            {fieldError?.message}
          </span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

TextField1.defaultProps = {
  autoFocus: false,
  value: "",
  errors: {},
  multiErrorFields: [],
  noNegative: false,
  errorIcon: "icon-error_outline",
  successIcon: "icon-checkmark",
  readOnly: false,
  required: true,
  noTextfield: false,
};

export default TextField1;
